import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Receipt } from "lucide-react";
import PricingInquiryForm from "./PricingInquiryForm";

export default function PricingHomeSection() {
  return (
    <section
      data-testid="pricing-home-section"
      className="py-20 md:py-28 bg-[#F8F4FB] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left copy */}
          <div className="lg:col-span-5">
            <div className="text-[11px] font-bold tracking-[0.22em] text-[#C43A89] uppercase mb-4 flex items-center gap-3">
              <span className="brand-dot bg-[#C43A89]" />
              Transparent Pricing · No Hidden Fees
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#29324A] leading-[1.05]">
              Visa Service Fees,{" "}
              <span className="text-[#29324A]">shared upfront</span>.
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Compare the current Department of Home Affairs application charge, typical market price across registered migration agents and our professional service fee — all in one transparent table.
            </p>

            <ul className="mt-6 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Receipt className="h-4 w-4 text-[#C43A89] mt-0.5 shrink-0" />
                <span className="text-slate-700"><strong className="text-[#29324A]">Government fees</strong> shown separately — payable directly to the Department.</span>
              </li>
              <li className="flex items-start gap-3">
                <ShieldCheck className="h-4 w-4 text-[#C43A89] mt-0.5 shrink-0" />
                <span className="text-slate-700"><strong className="text-[#29324A]">No commission</strong> from third parties — our fee is your fee.</span>
              </li>
            </ul>

            <Link
              to="/service-charges"
              data-testid="pricing-home-cta"
              className="mt-8 inline-flex items-center gap-2 bg-[#29324A] hover:bg-[#1f2638] text-white font-semibold py-3.5 px-7 transition-colors btn-shimmer"
            >
              View full service charges <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          {/* Right form */}
          <div className="lg:col-span-7">
            <PricingInquiryForm compact />
          </div>
        </div>
      </div>
    </section>
  );
}
